import ajaxUtils from './ajaxUtils';

export const refreshContactData = async refreshPayload => ajaxUtils.patch('/api/v1/revealed-contacts/snapshot', refreshPayload);
